<app-due-list [DueListfrom]="DueListfrom" [hideSomething]="true"></app-due-list>